"use strict";
/**
 * @module Services.LogRetrieval
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Data type for a FETCH_LOG_ENTRIES_SERVICE request.
 */
var EntriesFetchRequest = /** @class */ (function () {
    /**
     * Create a new EntriesFetchRequest instance
     *
     * @param firstEntry  the first log entry to fetch
     * @param entryCount  the number of log entries to fetch
     */
    function EntriesFetchRequest(firstEntry, entryCount) {
        this.firstEntry = firstEntry;
        this.entryCount = entryCount;
    }
    return EntriesFetchRequest;
}());
exports.EntriesFetchRequest = EntriesFetchRequest;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/log-retrieval/entries-fetch-request.js
// module id = 555
// module chunks = 1